"use client";

import { Facebook, Instagram, Youtube, Phone, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap gap-6 justify-center md:justify-start">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-white hover:text-white/80 transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer ref={footerRef} className="bg-dark-background text-foreground-dark py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <div className="space-y-4">
            <h3 className="text-lg font-display font-semibold mb-6 text-white">Quick Links</h3>
            <MenuProvider menu_id="9">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="text-lg font-display font-semibold mb-6">Find AB Studios</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Phone className="size-4 text-primary flex-shrink-0" />
                <Link to="tel:0411941883" className="text-sm transition-colors duration-[var(--duration-fast)] !text-[hsl(210,17%,98%)] hover:text-foreground">
                  0411 941 883
                </Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 text-primary flex-shrink-0" />
                <Link to="mailto:aidan.bartlett.photography@gmail.com" className="text-sm transition-colors duration-[var(--duration-fast)] break-all !text-[hsl(210,16%,93%)] hover:text-foreground">
                  aidan.bartlett.photography@gmail.com
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="size-4 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-sm !text-[hsl(0,0%,100%)]">Sydney, NSW</span>
              </div>
            </div>

            {}
            <div className="flex gap-4 pt-6">
              <Link to="https://www.facebook.com/profile.php?id=61573820862620" className="size-10 rounded-full bg-muted/10 hover:bg-primary flex items-center justify-center transition-all duration-[var(--duration-fast)] hover:scale-105" aria-label="Facebook">
                <Facebook className="size-5 text-primary" />
              </Link>
              <Link to="https://www.instagram.com/a.b_studios_/" className="size-10 rounded-full bg-muted/10 hover:bg-primary flex items-center justify-center transition-all duration-[var(--duration-fast)] hover:scale-105" aria-label="Instagram">
                <Instagram className="size-5 text-primary" />
              </Link>
              <Link to="#" className="size-10 rounded-full bg-muted/10 hover:bg-primary flex items-center justify-center transition-all duration-[var(--duration-fast)] hover:scale-105" aria-label="YouTube">
                <Youtube className="size-5 text-primary" />
              </Link>
            </div>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="text-lg font-display font-semibold mb-6">Find Us</h3>
            <div className="w-full h-64 bg-muted/10 rounded-md overflow-hidden">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d424143.4752793756!2d150.65176893281254!3d-33.84714479999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b129838f39a743f%3A0x3017d681632a850!2sSydney%20NSW%2C%20Australia!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="AB Studios Location"></iframe>
            </div>
          </div>
        </div>

        {}
        <div className={`mt-12 pt-8 border-t border-muted/20 text-center transition-all duration-[var(--duration-medium)] delay-150 ease-[var(--ease-out-back)] ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <p className="text-sm text-foreground">
            © {new Date().getFullYear()} AB Studios. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}